var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 2048 2048"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M662.6 1565.4 483 1385.8l360.6-360.6-363.5-363.4 182.6-182.6 363.5 363.4 359-359 179.6 179.6-359 359 362 362-182.6 182.6-362-362z"
})));
export default SvgX;